import { UserAuthRole } from 'lemunzo-api';

/**
 * Entra ID token `roles` claim values mapped to the generated platform role enum.
 * The claim strings exist only at this identity boundary - use `UserAuthRole` everywhere else.
 */
const USER_AUTH_ROLE_BY_CLAIM: Record<string, UserAuthRole> = {
    'Lemunzo.Client': UserAuthRole.User,
    'Lemunzo.Member': UserAuthRole.Member,
    'Lemunzo.Admin': UserAuthRole.Admin,
    'Lemunzo.Superadmin': UserAuthRole.SuperAdmin,
};

/**
 * Converts an Entra ID token role claim to `UserAuthRole`; unknown or missing claims yield `undefined`.
 */
export function userAuthRoleFromClaim(
    claim: string | undefined
): UserAuthRole | undefined {
    return claim ? USER_AUTH_ROLE_BY_CLAIM[claim] : undefined;
}

/**
 * Stable i18n key suffixes for all user roles, decoupled from the enum value.
 */
export const USER_ROLE_I18N_KEY: Record<UserAuthRole, string> = {
    [UserAuthRole.User]: 'client',
    [UserAuthRole.Member]: 'member',
    [UserAuthRole.Admin]: 'admin',
    [UserAuthRole.SuperAdmin]: 'superadmin',
};
